/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import * as z from "zod";
import type { ToZod } from "../.kubb/ToZod.ts";
import type { FeedbackClassStudentViewModelPaginatedResponse } from "../types/FeedbackClassStudentViewModelPaginatedResponse.ts";
import { feedbackClassStudentViewModelSchema } from "./feedbackClassStudentViewModelSchema.ts";

export const feedbackClassStudentViewModelPaginatedResponseSchema = z.object({
  data: z.array(z.lazy(() => feedbackClassStudentViewModelSchema)).nullish(),
  currentPage: z.optional(z.number().int()),
  totalPages: z.optional(z.number().int()),
  totalCount: z.optional(z.number().int()),
}) as unknown as ToZod<FeedbackClassStudentViewModelPaginatedResponse>;
